// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { createContext, useEffect, useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBK0A7THCVx7pP26xdpRA_QGdpLyTHKyPo",
  authDomain: "artzipper-landingpage.firebaseapp.com",
  projectId: "artzipper-landingpage",
  storageBucket: "artzipper-landingpage.appspot.com",
  messagingSenderId: "596190405377",
  appId: "1:596190405377:web:b08723b677bab3b3333100",
  measurementId: "G-S6LZW1213K",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const functions = getFunctions(app);

export const FireContext = createContext();

export default function Firebase({ props, children }) {
  const submitComingSoonForm = httpsCallable(functions, "submitComingSoonForm");
  const [doneLoading, setDoneLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    let timeout = 25;

    const unsubscribe = async () => {
      console.log("firebase unsub");
      setDoneLoading(true);
    };

    setTimeout(() => {
      if (mounted) {
        unsubscribe();
      }
    }, [timeout]);

    return () => (mounted = false);
  }, []);

  const submitForm = async (firstName, lastName, email) => {
    try {
      console.log(firstName, lastName, email);
      const response = await submitComingSoonForm({
        firstName: firstName,
        lastName: lastName,
        email: email,
      }); //
      const data = await response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  //Values that provider sends
  const values = { submitForm };
  return (
    <FireContext.Provider value={values}>
      {doneLoading && children}
    </FireContext.Provider>
  );
}
